/**
 * @desc 根据店铺标识查找财务收支账号信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.FinanceAccountResponseRpcDto>;
export function request(
  params: API.basics.platformSiteShopFacadeImpl.getFinanceAccountByShopKey.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/platformSiteShop/getFinanceAccountByShopKey`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
